var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSrtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 0L0 12.0027V22.9286L14.5712 31.253L19.5842 28.3716L15.4978 26.0367V19.9228L30.6006 11.2363L36.9691 14.874V22.1926L42 19.323V12.0027L20.9996 0ZM10.4694 23.1629L5.02831 20.0548V14.8765L9.5472 12.2938L14.155 14.9273L10.4686 17.049L10.4694 23.1629ZM19.1653 12.0434L14.5747 9.42082L20.9979 5.75012L25.5629 8.35996L19.1653 12.0434Z",
    fill: "#0285FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.415 19.6285L26.4997 21.9634V28.0773L11.3968 36.7638L5.02831 33.1261V25.8151L0 28.6813V35.9999L20.9996 48.0001L42 35.9999V25.074L27.4262 16.7471L22.415 19.6285ZM16.432 39.6426L22.8141 35.9669L27.4031 38.5894L20.9996 42.2483L16.432 39.6426ZM31.528 24.838L36.9674 27.9461V33.1244L32.4289 35.7181L27.8219 33.0863L31.528 30.9519V24.838Z",
    fill: "#0285FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrtIcon);
export default __webpack_public_path__ + "static/media/srt-icon.0cdbf451b5fcc8ae5220805b832d4f59.svg";
export { ForwardRef as ReactComponent };